import { Collapse, Flexbox, getPx } from 'components/spaceKit';
import styled from 'components/_UI/designSystem';

export const StyledCollapse = styled(Collapse)`
    [data-id='collapse-content'] > ${Flexbox} {
        > * + * {
            margin-top: ${getPx(3)};
        }
    }
`;
